import React, { useState, useEffect, Fragment } from 'react';
import JHApi from "../../utils/JHApi"
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Switch,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { displayPrice } from '../../utils/utils';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import clsx from 'clsx';
import ReactGA from 'react-ga4'

const useStyles = makeStyles((theme) => ({
    plansContainer:{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row-reverse',
        marginTop: 16
    },
    pricingPlan:{
        width: '100%',
        position: 'relative',
        backgroundColor: '#ececec',
        borderRadius: 15,
        maxWidth: 290,
        boxShadow: '0 1px 2px 0 rgba(22, 45, 61, .1)',
        marginBottom: 15,
        textAlign: 'center',
        marginTop: 68,
        marginLeft: 15,
        marginRight: 15,
        padding: 24,
        paddingTop: 32,
    },
    recommendedPlan:{
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        marginTop: '16px !important',
        maxWidth: '320px !important',
        paddingTop: 40,
        backgroundColor: '#e8d5f0',
        position: 'relative',
        '&::before': {
            content: '"המלצת צוות"',
            position: 'absolute',
            top: -15,
            padding: '4px 12px 1px',
            color: '#b620e0',
            fontWeight: '700',
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: '0px 0px 2px 1px rgb(211 211 211)',
            fontSize: 16,
            letterSpacing: '0.4px',
            right: 'calc(50% - 55px)'
        },
    },
    planTitle:{
        fontWeight: 800,
        lineHeight: 1,
        fontSize: 20,
        marginBottom: 8
    },
    planDesc:{
        fontSize: 16,
        direction: 'rtl',
        marginBottom: 8
    },
    item: {
        display: "flex",
        alignItems: "flex-start",
        marginTop: theme.spacing(1.5),
    },
    icon: {
        marginLeft: theme.spacing(1),
        marginTop: 4,
        fontSize: 16,
    },
    check: {
        color: "#0000008a",
    },
    close: {
        color: "#f44336",
    },
}))

const AlwaysActiveSwitch = withStyles({
    switchBase: {
      color: "#aa4dc8",
      "&$checked": {
        color: "#aa4dc8",
      },
      "&$checked + $track": {
        backgroundColor: "#aa4dc8",
        opacity: 0.3,
      },
    },
    track: {
      backgroundColor: "#aa4dc8",
      opacity: 0.3,
    },
    checked: {},
})(Switch);

function TwoSideSwitch({
    leftLabel = "Option 1",
    rightLabel = "Option 2",
    value,
    onChange
}) {
    const handleChange = () => {
        onChange();
    };
  
    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr auto 1fr"
            alignItems="center"
            width="100%"
        >
            <Typography
                style={{
                    marginRight: 8,
                    fontWeight: !value ? 600 : 400,
                    whiteSpace: 'pre-line',
                    opacity: !value ? 1 : 0.6,
                    fontSize: 14
                }}
            >
            {leftLabel}
            </Typography>
    
            <AlwaysActiveSwitch
                checked={value}
                onChange={handleChange}
            />
    
            <Typography
                style={{
                    marginLeft: 8,
                    fontWeight: value ? 600 : 400,
                    whiteSpace: 'pre-line',
                    opacity: value ? 1 : 0.6,
                    fontSize: 14
                }}
            >
            {rightLabel}
            </Typography>
        </Box>
    );
}

const FeatureItem = (props) => {
    const classes = useStyles();
  
    return (
        <div className={classes.item}>
            {props.notIncluded ? (
                <CloseIcon className={`${classes.icon} ${classes.close}`} />
            ) : (
                <CheckIcon className={`${classes.icon} ${classes.check}`} />
            )}
            <div style={{fontSize: 16}}>{props.children}</div>
        </div>
    );
};

export default function Pricing(props) {
    const [terms, setTerms] = useState('');
    const [plans, setPlans] = useState({});
    const [plansArray, setPlansArray] = useState([]);
    const [switcheState, setswitcheState] = useState({});
    const [paymentLink, setPaymentLink] = useState();
    const [GAInfo, setGAInfo] = useState({});

    useEffect(() => {
        JHApi.getPricingData({},(response)=>{
            setTerms(response.terms || '')
            setPlans(response.plans || {})
            setPlansArray(response.plansArray || [])
            setswitcheState(response.switchDefs || {})
        }, (error) => {
            
        })
    }, []);

    const handleChangeSwitch = plan => {
        setswitcheState({...switcheState, [plan]:!switcheState[plan]})
    }

    const handleShowTerms = plansName => {
        if (switcheState[plansName]){
            ReactGA.event({category: `Journey`, action: `open_terms_${plansName}`, label:'payments'})
            setGAInfo({plansName:plansName, label: 'payments'})
            setPaymentLink(plans[plansName].paymentsLink)
        } else {
            ReactGA.event({category: `Journey`, action: `open_terms_${plansName}`, label:'payment'})
            setGAInfo({plansName:plansName, label: 'payment'})
            setPaymentLink(plans[plansName].paymentLink)
        }
    }

    const classes = useStyles();

    return (
        <div>
            {/*<div>
                <Typography dir="auto" variant='h2' style={{textAlign: 'center', fontFamily: 'arial'}}>
                    חוויה מעצימה של חיפוש עבודה, <br/>
                    יד ביד, איתך, עד להצלחה!
                </Typography>
                <Typography dir="auto" variant='h6' style={{textAlign: 'right', fontFamily: 'arial', maxWidth: 580,  margin: '8px auto', fontWeight: 'bold'}}>
                    כי יש לך כבר את כל מה שצריך <br/>
                    ואנחנו נגרום לכולם לדעת את זה
                </Typography>
                <Typography dir="auto" variant='body1' style={{textAlign: 'right', fontFamily: 'arial', maxWidth: 580,  margin: '8px auto'}}>
                    המומחיות שלנו היא לאתר ולהבליט את הכישורים שלך, שעושים אותך, טאלנט אמיתי, לבנות לך קורות חיים של טאלנט, ובאמצעות חשיפה עוצמתית לאנשים הכי רלוונטיים בתעשייה המקומית - להגיע בדיוק למשרת החלומות שלך, לפעמים עוד לפני שהמשרה בכלל מתפרסמת.
                </Typography>
            </div>*/}

            {(plansArray.length > 0) && <div>
                <Typography dir="auto" variant='h6' style={{textAlign: 'center', fontFamily: 'arial', direction: 'rtl', margin: '36px 0', fontSize: 20, lineHeight: '26px'}}>
                    JobHunt מעניקה לך גישה לרשת של כ-13,000 אנשי קשר בחברות בתעשיה, <br/>
                    וליווי אישי צמוד. <br/><br/>
                    <b>במהירות ויעילות תתחילו קריירה ,תעלו בדרגה ותשפרו שכר.</b>
                </Typography>
            </div>}

            {plansArray.length === 0 ? <LinearProgress />:<>
            <Dialog onClose={()=> setPaymentLink()} open={paymentLink !== undefined} maxWidth='lg'>
                <DialogTitle style={{textAlign: 'right', direction: 'rtl'}}>תנאי שירות JobHunt</DialogTitle>
                <DialogContent dividers>
                    <div style={{textAlign: 'right', direction: 'rtl'}} dangerouslySetInnerHTML={{__html: terms}} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>ReactGA.event({category: `Journey`, action: `payment_link_${GAInfo.plansName}`, label:GAInfo.label})} variant="contained" target='_blank' href={paymentLink} color="primary" aria-label="קראתי ואני מאשר את תנאי השירות">
                        קראתי ואני מאשר את תנאי השירות
                    </Button>
                </DialogActions>
            </Dialog>

            <div className={classes.plansContainer}>
                {plansArray.map((plansName) => {
                    const plan = plans[plansName]
                    
                    return (
                        <Fragment key={plansName}>
                            {(!plan.morePlans)&&<div className={clsx(classes.pricingPlan, plan.isPopular&&classes.recommendedPlan)}>
                                <Typography variant='h6' className={classes.planTitle}>{plan.label}</Typography>
                                <Typography className={classes.planDesc}>{plan.desc}</Typography>
                                
                                {(switcheState[plansName]!==undefined)&&<TwoSideSwitch
                                    leftLabel="תשלום מראש
                                                חיסכון 5%"
                                    rightLabel="תשלומים"
                                    value={switcheState[plansName]}
                                    onChange={()=>handleChangeSwitch(plansName)}
                                />}

                                <div style={{direction: 'rtl', height: 96, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    {switcheState[plansName] ? <div>
                                        <div style={{fontSize: 32, lineHeight: 1, display: 'inline'}}>{displayPrice(plan.paymentsPrice)}</div>
                                        <span style={{fontSize: 16}}>₪</span>
                                        <div style={{display: 'flex', justifyContent: 'center'}}>
                                            <div>X</div>
                                            <div style={{margin: '0 4px'}}>{plan.paymentCount}</div>
                                            <div>תשלומים</div>
                                        </div>
                                    </div>:<div>
                                        <div style={{display: 'inline-block', marginBottom: 8, marginTop: '-8px'}}>
                                            <div style={{width: 75, height: 1, backgroundColor: '#3f3f40', position: 'relative', top: 12, transform: 'rotate(158deg)'}}></div>
                                            <div style={{fontSize: 28, lineHeight: 1, display: 'inline', color: '#3f3f3f'}}>{displayPrice(plan.priceRemoved)}</div>
                                            <span>₪</span>
                                        </div><br/>
                                        <div  style={{fontSize: 32, lineHeight: 1, display: 'inline'}}>{displayPrice(plan.onePaymentPrice)}</div>
                                        <span>₪</span>
                                    </div>}
                                </div>

                                <Button variant="contained" color='primary' onClick={()=>handleShowTerms(plansName)}>
                                    רישום לתוכנית
                                </Button>

                                <div style={{textAlign:'right', direction: 'rtl'}}>
                                    <div style={{marginTop: 16, lineHeight: 1.2, fontWeight: 'bold', fontSize: 16}}><div dangerouslySetInnerHTML={{ __html: plan.afterPriceDesc }}/></div>

                                    {plan.rowMonthly.map((service) => (
                                        <FeatureItem key={service.label}><div dangerouslySetInnerHTML={{ __html: service.label }}/></FeatureItem>
                                    ))}
                                </div>
                            </div>}
                        </Fragment>
                    )
                })}
            </div>

            <div style={{textAlign: 'center', margin: '16px 0'}}>
                <Button color='primary' variant='contained' href="https://jobhunt.co.il/pricing/#faqs" target="_blank">שאלות ותשובות</Button>
            </div>
            </>}
        </div>
    )
}